import { track } from '@zillow/universal-analytics';

export const GA_CATEGORY = 'HomeWorthPropertySearch';
export const PROPERTY_SEARCH_ACTION = 'AddressSubmit';
export const REVIEW_LIGHTBOX_ACTION = 'Review';
export const CONTACT_LIGHTBOX_ACTION = 'Contact';

export function concatWithPipe(labelPieces: string[]): string {
    return labelPieces.filter(Boolean).join('|');
}

export const getIsSemTraffic = (query?: { sem: string }) => {
    if (query !== undefined) {
        const semBoolean = query.sem === 'true';
        return semBoolean;
    }
    return false;
};

export const getTrafficLabel = (query) =>
    getIsSemTraffic(query) ? 'SEM_PaidContactForm' : 'SEL_OrganicContactForm';

const getEvent = (config) =>
    track({
        ...config,
        category: GA_CATEGORY,
    });

export const trackHdpLinkClick = (surfaceId: string, placementId: string) =>
    getEvent({
        action: REVIEW_LIGHTBOX_ACTION,
        label: concatWithPipe(['Click', surfaceId, placementId, 'view-home']),
    });

export const trackFSBOClick = (surfaceId: string, placementId: string) =>
    getEvent({
        action: REVIEW_LIGHTBOX_ACTION,
        label: concatWithPipe(['Click', surfaceId, placementId, 'list-fsbo']),
    });

export const trackSellingTipsClick = (surfaceId: string, placementId: string) =>
    getEvent({
        action: REVIEW_LIGHTBOX_ACTION,
        label: concatWithPipe(['Click', surfaceId, placementId, 'selling-tips']),
    });

export const trackContactAgentFormLinkClick = (surfaceId: string, placementId: string) =>
    getEvent({
        action: REVIEW_LIGHTBOX_ACTION,
        label: concatWithPipe(['Click', surfaceId, placementId, 'contact-agent']),
    });

export const trackHmimhwPropertySearchDisplay = (placementId: string, surfaceId: string) =>
    getEvent({
        action: PROPERTY_SEARCH_ACTION,
        label: concatWithPipe(['Display', surfaceId, placementId]),
    });

export const trackAddressSearch = (surfaceId: string, placementId: string) =>
    getEvent({
        action: PROPERTY_SEARCH_ACTION,
        label: concatWithPipe(['Search', surfaceId, placementId]),
    });

export const trackHmimhwPropertySearchError = (
    placementId: string,
    surfaceId: string,
    error: string
) =>
    getEvent({
        action: PROPERTY_SEARCH_ACTION,
        label: concatWithPipe(['Failure', surfaceId, placementId, error]),
    });

export const trackHmimhwReviewLightboxDisplay = (surfaceId: string, placementId: string) =>
    getEvent({
        action: REVIEW_LIGHTBOX_ACTION,
        label: concatWithPipe(['Display', surfaceId, placementId]),
    });

export const trackHmimhwContactDisplay = (surfaceId: string, placementId: string) =>
    getEvent({
        action: CONTACT_LIGHTBOX_ACTION,
        label: concatWithPipe(['Display', surfaceId, placementId]),
    });
